import { createReducer } from '@reduxjs/toolkit';
import t from '@/store/types';

const initialState: { data: Record<string, any>; loading: boolean } = {
  data: {},
  loading: false,
};

export default createReducer(initialState, (builder) => {
  builder.addCase(t.CURRENCIES_REGISTERED_SET, (state, action: any) => {
    const _currencies: Record<string, any> = {};

    action.currencies.forEach((currency: any) => {
      _currencies[currency.currency_code] = currency;
    });
    state.data = {
      ...state.data,
      ..._currencies,
    };
  });
  builder.addCase(t.CURRENCIES_TABLE_LOADING, (state, action: any) => {
    state.loading = action.loading;
  });
  builder.addCase(t.CURRENCY_CODE_DELETE, (state, action: any) => {
    if (typeof state.data[action.currency_code] !== 'undefined') {
      delete state.data[action.currency_code];
    }
  });
});
